import { useMemo, useRef } from "react";

import { EntityHelper } from "@/common/helpers/entity";
import { EntityInputFormInfo } from "@/common/ts/entity";
import { BaseEntityDto } from "@/core/api/generated/v1";

interface Props {
  entityId: Nil<string>;
  entity?: Nil<BaseEntityDto>;
}

export function useEntityInputFormInfo({ entityId, entity }: Props): EntityInputFormInfo {
  const entityIdComputed = entity?.id || entityId;

  const formInfo = useMemo(
    () => EntityHelper.getEntityInputFormInfoByEntityId(entityIdComputed),
    [entityIdComputed],
  );

  const resultRef = useRef<EntityInputFormInfo>(formInfo);
  if (formInfo.entityId !== entityIdComputed) {
    resultRef.current = {
      ...resultRef.current,
      ...formInfo,
    };
  }

  return resultRef.current;
}
